export const getNoPiiDisplayValue = (noPII, translate) => {
    return noPII ? translate('Username only') : translate('Off (Study default)');
};
